



























































import { Component, Vue, Ref } from 'vue-property-decorator'
import {
  groupIntraAnalysis,
  getClassList
} from '@/api/teachingProtection/assessment'
import Status from './_components/Status.vue'
import Score from './_components/Score.vue'

@Component({
  components: {
    Status,
    Score
  }
})
export default class extends Vue {
  private tabData = [
    { code: 101, description: '状态分布比例' }
    // { code: 102, description: '得分分布' }
  ];
  private tabActive = 101;
  private searchParams = {
    classroomId: '',
    name: '',
    fromTime: '',
    toTime: '',
    formModelId: ''
  };
  private info = {
    heightDistribute: { title: '身高分布', details: [] },
    bmidistribute: { title: 'BMI分布', details: [] },
    synthEZAvgScore: { title: '综合能力均分', details: [] },
    synthEZDistribute: { title: '综合能力分布', details: [] }
  };
  // 身高分布数据
  private chartHeightData = [];
  // BMI分布数据
  private chartBMIData = [];
  // 综合能力均分
  private chartAvgData = [];
  // 综合能力分布
  private chartFBData = [];
  private classroomName: any = '';
  private sexName: any = '';
  private compareName: any = '';
  private tabPosition: any = '';
  private classNames: any = [];
  private params: any = {};
  private chartShow: any = false;
  created() {
    if (!this.$route.query.searchParams) return
    this.params = JSON.parse(this.$route.query.searchParams as string)
    localStorage.setItem('searchParams', JSON.stringify(this.params))
    const params = JSON.parse(
      (this as any).$route.query.searchParams as string
    )
    const classroomNames: any = []
    const sexNames: any = []
    const compareNames: any = []
    getClassList({
      periodType: params.periodType,
      year: params.year,
      semesterType: params.semesterType
    }).then((res: any) => {
      res.data.array.map((v: any) => {
        v.classrooms.map((q: any) => {
          if (this.params.classroomIds.indexOf(q.id) !== -1) {
            classroomNames.push(q.name)
          }
        })
      })
      this.classroomName = classroomNames.join('、')
    })
    this.$enums.gender.map((v: any) => {
      if (this.params.sexes.indexOf(v.code) !== -1) {
        sexNames.push(v.description)
      }
    })
    this.sexName = sexNames.join('、')
    this.$enums.classroomTypes.map((v: any) => {
      if (this.params.compareIds.indexOf(v.code) !== -1) {
        compareNames.push(v.description)
        this.classNames.push({
          name: v.description,
          code: v.code
        })
      }
    })
    this.compareName = compareNames.join('、')
    if (!(this.params.classroomIds.length > 0)) {
      // this.params.compareIds = [this.params.compareIds[0]]
      this.tabPosition = this.classNames[0].code
    }
    groupIntraAnalysis(this.params).then((res: any) => {
      this.$fn.setVal(this.info, res.data)
    })
    this.chartShow = true
  }
  tabChange(tab: any) {
    this.params.compareIds = [tab]
    console.info(this.params)
    // groupIntraAnalysis(this.params).then((res: any) => {
    //   this.$fn.setVal(this.info, res.data)
    // })
    this.chartShow = false
    this.$nextTick(() => {
      this.chartShow = true
    })
  }
  private reset() {
    this.$fn.resetObject(this.searchParams);
    (this.$refs.table as any).search()
  }
  private search() {
    (this.$refs.table as any).update()
  }
}
